/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { helpCenterSettingsCustomerNotificationsAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-customer-notifications/src/helpCenterSettingsCustomerNotificationsAppEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type helpCenterSettingsCustomerNotificationsType from '@jira/spa-apps__help-center-settings-customer-notifications/src/ExportedComponent.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import {
	usePathParam,
	type HistoryAction,
	type Location,
	type Match,
	type Query,
	type Route,
} from '@atlassian/react-resource-router';

export const helpCenterSettingsCustomerNotificationsAppPageEntryPoint: ReturnType<
	typeof createPageEntryPoint
> = createPageEntryPoint({
	main,
});

export const LazyHelpCenterSettingsCustomerNotifications: LazyComponent<{
	(props: {
		location: Location;
		query: Query;
		route: Route;
		match: Match;
		action: HistoryAction;
	}): React.JSX.Element;
	displayName: string;
}> = lazyForPaint<typeof helpCenterSettingsCustomerNotificationsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-help-center-settings-customer-notifications", jiraSpaEntry: "async-help-center-settings-customer-notifications" */ '@jira/spa-apps__help-center-settings-customer-notifications/src/ExportedComponent.tsx'
		),
	),
);

export const HelpCenterSettingsCustomerNotifications = (): React.JSX.Element => {
	const [helpCenterId] = usePathParam('helpCenterId');
	return (
		<LazyPage
			// Customer notifications page does not handle projectKey change so we're passing the helpCenterId as a key to force a re-render
			key={helpCenterId}
			Page={LazyHelpCenterSettingsCustomerNotifications}
			pageId="help-center-settings-customer-notifications"
			shouldShowSpinner
		/>
	);
};
